module.exports = __webpack_public_path__ + "static/media/expiredNotAvailable.a7db0944.svg";